import { useState } from 'react'
import { useDivineVideo } from '@/hooks/useDivineVideo'
import { Spinner } from '@/components/Spinner'

interface DivineEmbedProps {
    eventId: string
    title?: string
}

export function DivineEmbed({ eventId, title }: DivineEmbedProps) {
    const { data, isLoading, isError } = useDivineVideo(eventId)
    const [videoError, setVideoError] = useState(false)

    if (isError || videoError) return null

    const paddingTop = data?.dimensions
        ? `${(data.dimensions.height / data.dimensions.width) * 100}%`
        : '100%'

    return (
        <div
            className="relative rounded-lg overflow-hidden border border-border-light dark:border-border-dark bg-black"
            style={{ paddingTop }}
            onClick={e => e.stopPropagation()}
        >
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <Spinner />
                </div>
            )}
            {data && (
                <video
                    className="absolute inset-0 w-full h-full object-contain"
                    poster={data.thumbnailUrl}
                    autoPlay
                    controls
                    loop
                    muted
                    playsInline
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty title should fall back to the default label, not render blank
                    aria-label={title || 'Divine.video'}
                    onError={() => setVideoError(true)}
                >
                    {/* HLS first — Safari plays natively; Chrome falls back to MP4 */}
                    {data.hlsUrl && <source src={data.hlsUrl} type="application/x-mpegURL" />}
                    <source src={data.videoUrl} type="video/mp4" />
                </video>
            )}
        </div>
    )
}
